import React, { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  es: {
    // Nav
    "nav.home": "Inicio",
    "nav.experiences": "Experiencias",
    "nav.contact": "Contacto",
    "nav.book": "Reservar ahora",
    // Home
    "home.eyebrow": "Benova Travel Group — Riviera Maya",
    "home.hero_title_default": "Tu Riviera Maya,\ndiseñada a tu medida",
    "home.hero_subtitle_default": "Experiencias curadas, yates privados, ruinas mayas e islas de ensueño.",
    "home.explore": "Explorar experiencias",
    "home.see_catalog": "Ver catálogo",
    "home.scroll": "Scroll",
    "home.featured_eyebrow": "Handpicked",
    "home.featured_title": "Las experiencias que definen la Riviera",
    "home.see_all": "Ver todas",
    "home.catalog_eyebrow": "Catálogo completo",
    "home.catalog_title": "Descubre, reserva, vive.",
    "home.val_eyebrow": "Pregúntale a {name}",
    "home.val_title": "¿No sabes por dónde empezar?\n{name} tiene la respuesta.",
    "home.val_subtitle": "Tu concierge IA para la Riviera Maya. Te arma el itinerario perfecto y te dice dónde, cuándo y por qué.",
    "home.filter_all": "Todas",
    // Experiences list
    "exp.eyebrow": "Riviera Maya",
    "exp.title": "Todas nuestras experiencias",
    // Detail
    "detail.includes": "Qué incluye",
    "detail.video": "Video",
    "detail.maps": "Ver en Google Maps",
    "detail.per_person": "/ persona",
    "detail.date": "Fecha",
    "detail.people": "Personas",
    "detail.total": "Total",
    "detail.book_now": "Reservar ahora",
    "detail.pay_safe": "Pago seguro · Cancelación gratis hasta 24h antes",
    "detail.select_date_first": "Selecciona una fecha para continuar",
    // Booking form
    "book.step": "Paso 2 de 2",
    "book.title": "Tus datos",
    "book.subtitle": "Completa tu información para generar el ticket y pagar.",
    "book.name": "Nombre completo",
    "book.email": "Email",
    "book.whatsapp": "WhatsApp / Teléfono",
    "book.notes": "Notas (opcional)",
    "book.coupon": "¿Tienes un código de descuento?",
    "book.coupon_placeholder": "Ingresa tu código",
    "book.coupon_apply": "Aplicar",
    "book.coupon_applied": "Cupón aplicado",
    "book.coupon_invalid": "Cupón inválido o expirado",
    "book.summary": "Resumen",
    "book.price_per": "Precio por persona",
    "book.discount": "Descuento",
    "book.submit": "Pagar con tarjeta",
    "book.redirect_note": "Serás redirigido a Stripe para el pago seguro.",
    "book.processing": "Procesando...",
    // Payment success
    "pay.checking": "Procesando pago",
    "pay.confirming": "Confirmando tu pago con Stripe...",
    "pay.expired": "Sesión expirada",
    "pay.expired_desc": "No pudimos confirmar tu pago. Intenta de nuevo.",
    "pay.back_catalog": "Volver al catálogo",
    "pay.confirmed": "¡Reserva confirmada!",
    "pay.email_sent": "Te enviamos el resumen por email. Guarda este ticket.",
    "pay.code": "Código",
    "pay.holder": "Titular",
    "pay.phone": "Teléfono",
    "pay.total_paid": "Total pagado",
    "pay.scan_verify": "Escanea para verificar",
    "pay.share_wa": "Compartir por WhatsApp",
    "pay.print": "Imprimir / PDF",
    // Ticket
    "ticket.valid": "Ticket Válido",
    "ticket.invalid": "Ticket Pendiente / Inválido",
    "ticket.booking": "Reserva",
    "ticket.not_found": "Ticket no encontrado",
    // Val
    "val.placeholder": "Pregúntale a {name}...",
    "val.online": "En línea · Benova Travel",
    "val.error": "Uy, tuve un problema 😔. Escríbeme de nuevo en un momento.",
    // Footer
    "footer.nav": "Navegación",
    "footer.contact": "Contacto",
    "footer.tagline": "Benova Travel Group es tu curador personal de experiencias de lujo en la Riviera Maya. Cada viaje, una historia.",
    "footer.made_in": "Hecho con cariño en México",
    // Common
    "common.loading": "Cargando...",
    "common.cancel": "Cancelar",
    "common.save": "Guardar",
  },
  en: {
    "nav.home": "Home",
    "nav.experiences": "Experiences",
    "nav.contact": "Contact",
    "nav.book": "Book now",
    "home.eyebrow": "Benova Travel Group — Riviera Maya",
    "home.hero_title_default": "Your Riviera Maya,\ndesigned for you",
    "home.hero_subtitle_default": "Curated experiences, private yachts, Mayan ruins and dream islands.",
    "home.explore": "Explore experiences",
    "home.see_catalog": "See catalog",
    "home.scroll": "Scroll",
    "home.featured_eyebrow": "Handpicked",
    "home.featured_title": "The experiences that define the Riviera",
    "home.see_all": "See all",
    "home.catalog_eyebrow": "Full catalog",
    "home.catalog_title": "Discover, book, live it.",
    "home.val_eyebrow": "Ask {name}",
    "home.val_title": "Don't know where to start?\n{name} has the answer.",
    "home.val_subtitle": "Your AI concierge for the Riviera Maya. She builds your perfect itinerary and tells you where, when and why.",
    "home.filter_all": "All",
    "exp.eyebrow": "Riviera Maya",
    "exp.title": "All our experiences",
    "detail.includes": "What's included",
    "detail.video": "Video",
    "detail.maps": "View on Google Maps",
    "detail.per_person": "/ person",
    "detail.date": "Date",
    "detail.people": "People",
    "detail.total": "Total",
    "detail.book_now": "Book now",
    "detail.pay_safe": "Secure payment · Free cancellation up to 24h before",
    "detail.select_date_first": "Select a date to continue",
    "book.step": "Step 2 of 2",
    "book.title": "Your details",
    "book.subtitle": "Complete your information to generate the ticket and pay.",
    "book.name": "Full name",
    "book.email": "Email",
    "book.whatsapp": "WhatsApp / Phone",
    "book.notes": "Notes (optional)",
    "book.coupon": "Got a discount code?",
    "book.coupon_placeholder": "Enter your code",
    "book.coupon_apply": "Apply",
    "book.coupon_applied": "Coupon applied",
    "book.coupon_invalid": "Invalid or expired coupon",
    "book.summary": "Summary",
    "book.price_per": "Price per person",
    "book.discount": "Discount",
    "book.submit": "Pay by card",
    "book.redirect_note": "You'll be redirected to Stripe for secure payment.",
    "book.processing": "Processing...",
    "pay.checking": "Processing payment",
    "pay.confirming": "Confirming your payment with Stripe...",
    "pay.expired": "Session expired",
    "pay.expired_desc": "We couldn't confirm your payment. Please try again.",
    "pay.back_catalog": "Back to catalog",
    "pay.confirmed": "Booking confirmed!",
    "pay.email_sent": "We've sent you a summary by email. Save this ticket.",
    "pay.code": "Code",
    "pay.holder": "Holder",
    "pay.phone": "Phone",
    "pay.total_paid": "Total paid",
    "pay.scan_verify": "Scan to verify",
    "pay.share_wa": "Share on WhatsApp",
    "pay.print": "Print / PDF",
    "ticket.valid": "Valid Ticket",
    "ticket.invalid": "Pending / Invalid Ticket",
    "ticket.booking": "Booking",
    "ticket.not_found": "Ticket not found",
    "val.placeholder": "Ask {name}...",
    "val.online": "Online · Benova Travel",
    "val.error": "Oops, something went wrong 😔. Write me again in a moment.",
    "footer.nav": "Navigation",
    "footer.contact": "Contact",
    "footer.tagline": "Benova Travel Group is your personal curator of luxury experiences in the Riviera Maya. Every trip, a story.",
    "footer.made_in": "Made with love in Mexico",
    "common.loading": "Loading...",
    "common.cancel": "Cancel",
    "common.save": "Save",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("benova_lang") || "es");

  useEffect(() => {
    localStorage.setItem("benova_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const t = (key, vars = {}) => {
    const dict = DICT[lang] || DICT.es;
    let s = dict[key] || DICT.es[key] || key;
    Object.entries(vars).forEach(([k, v]) => { s = s.replace(`{${k}}`, v); });
    return s;
  };

  const toggle = () => setLang((l) => (l === "es" ? "en" : "es"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang outside provider");
  return ctx;
}
